import { render, staticRenderFns } from "./PageHome.vue?vue&type=template&id=7b2dd8ae&"
import script from "./PageHome.vue?vue&type=script&lang=ts&"
export * from "./PageHome.vue?vue&type=script&lang=ts&"
import style0 from "./PageHome.vue?vue&type=style&index=0&id=7b2dd8ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports